export class ImageService {
	static resizeImage(
		src: string,
		width: number,
		height: number,
		scale: number = 1
	): string | undefined {
		const API_CDN_URL = 'https://d14j9vfj10qgpp.cloudfront.net'
		const API_IMAGES_URL = 'https://d3rhcahk56mofm.cloudfront.net'

		const imagePath = this.extractImagePath(src)
		if (!imagePath || imagePath.domain !== API_CDN_URL) return src

		const resizeOptions = this.getResizeOptions(width, height, scale)
		const imageOptions = this.getImageOptions()

		return this.generateImageUrl(API_IMAGES_URL, imagePath.key, resizeOptions, imageOptions)
	}

	private static extractImagePath(src: string): { domain: string; key: string } | null {
		const match = /(https?:\/\/[^/]*)\/(.*)/.exec(src)
		if (!match) return null
		return { domain: match[1], key: match[2] }
	}

	private static getResizeOptions(width: number, height: number, scale: number) {
		return { width: width * scale, height: height * scale, withoutEnlargement: true }
	}

	private static getImageOptions() {
		return {
			lossless: false,
			quality: 90,
			nearLossless: false,
			smartSubsample: false,
		}
	}

	private static generateImageUrl(
		baseUrl: string,
		key: string,
		resize: { width: number; height: number; withoutEnlargement: boolean },
		imageOptions: object
	): string {
		const options = {
			resize,
			toFormat: 'webp',
			webp: imageOptions,
		}
		const imageRequest = JSON.stringify({ key, edits: options })
		return `${baseUrl}/${btoa(imageRequest)}`
	}
}
